import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPNameSectionPlaceholder from '../PDPNameSection/PDPNameSectionPlaceholder';
import PDPShopTabsBarPlaceholder from '../PDPShopTabsBar/PDPShopTabsBarPlaceholder';
import PDPChooseYourOptionsPlaceholder from '../PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from '../PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from '../PDPAddToBagSection/PDPAddToBagSectionPlaceholder';
import PDPSellingAttributesPlaceholder from '../PDPSellingAttributes/PDPSellingAttributesPlaceholder';
import PDPProductDescriptionPlaceholder from '../PDPProductDescription/PDPProductDescriptionPlaceholder';
const PDPDesktopPlaceholder = t0 => {
  const $ = _c(9);
  const {
    className: parentClassName
  } = t0;
  let t1;
  if ($[0] !== parentClassName) {
    t1 = classNames("hidden lg:flex mx-auto my-0 py-0 flex-row-reverse !pt-2 !pb-8 px-5 md:px-[3.333vw] min-[1500px]:px-[50px] max-w-[1800px]", parentClassName);
    $[0] = parentClassName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex-none min-w-[460px] w-[460px] [@media(width:1024px)]:min-w-[400px] [@media(width:1024px)]:w-[400px]"><PDPNameSectionPlaceholder /><PDPShopTabsBarPlaceholder /><PDPChooseYourOptionsPlaceholder /><PDPProtectionPlanSelectorPlaceholder /><PDPAddToBagSectionPlaceholder /><PDPSellingAttributesPlaceholder /><PDPProductDescriptionPlaceholder /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="max-[1023px]:hidden z-auto m-0 mt-0 pt-2 pl-5 min-h-[45px] static bg-transparent border-0 [&_a]:text-gray-light1 [&_li:last-child_span]:last:text-gray-light1 [&_a:hover]:text-white sm:pt-0 sm:pl-0 md:mt-2"><Placeholder loading={true} type="text" style={{
        width: "512px"
      }} /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maxWidth: "calc((100vh - 194px) / 0.6666666666666666)"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-8 flex flex-col items-center relative" style={t4}><Placeholder loading={true} type="rect" style={{
        width: "50vw",
        height: "70vh",
        margin: "none"
      }} /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex-1 mr-12">{t3}<div className="sticky top-8">{t5}<div className="flex flex-row justify-center mt-8 p-0 w-full"><Placeholder loading={true} type="rect" style={{
            width: "450px",
            height: "60px",
            margin: "none"
          }} /></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1) {
    t7 = <div className={t1}>{t2}{t6}</div>;
    $[7] = t1;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
export default PDPDesktopPlaceholder;